import type { ReportBucket, ReportGroupBy } from "@/types/production-report.types";

// Spec 083 — o rótulo do agrupamento na tela.
//
// Data civil em pt-BR, sem hora: o relatório trabalha em datas, e mostrar hora sugeriria uma
// precisão que o dado não tem. `Date` só é construído com `T00:00:00` explícito — sem isso, o
// navegador interpreta `YYYY-MM-DD` como UTC e um fuso negativo mostra o dia anterior.

const DIA = new Intl.DateTimeFormat("pt-BR", { day: "2-digit", month: "2-digit" });
const MES = new Intl.DateTimeFormat("pt-BR", { month: "short", year: "numeric" });

function toDate(iso: string): Date {
  return new Date(`${iso}T00:00:00`);
}

export function formatBucketLabel(bucket: ReportBucket, groupBy: ReportGroupBy): string {
  if (groupBy === "month") return MES.format(toDate(bucket.key));
  if (groupBy === "day") return DIA.format(toDate(bucket.key));
  return `${DIA.format(toDate(bucket.from))} – ${DIA.format(toDate(bucket.to))}`;
}
